import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/button';

import { ResultState } from '../../../../common/ui/result-state';
import ErrorDark from './assets/error-dark.svg';
import ErrorLight from './assets/error-light.svg';
import { getCachedImage } from './image-cache';
import { messages } from './messages';

type ErrorProps = {
	fetchResults: () => void;
};

export const Error = ({ fetchResults }: ErrorProps): React.JSX.Element => {
	const ImageErrorLight = getCachedImage('cachedImageErrorLight') || ErrorLight;
	const ImageErrorDark = getCachedImage('cachedImageErrorDark') || ErrorDark;

	return (
		<>
			<ResultState
				imageSrcLight={ImageErrorLight}
				imageSrcDark={ImageErrorDark}
				primaryText={<FormattedMessage {...messages.errorPrimary} />}
				secondaryText={
					<FormattedMessage
						{...messages.errorSecondary}
						values={{
							btn: (chunks: React.ReactNode[]) => (
								<Button appearance="link" spacing="none" onClick={fetchResults}>
									{chunks}
								</Button>
							),
						}}
					/>
				}
				testId="search-page-error"
			/>
		</>
	);
};
